import styled from "@emotion/styled";
import { timelineColors } from "./studio/theme/config";

export const EditorContainer = styled.div`
  background-color: ${timelineColors.bg};
  height: calc(100vh);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  @media (max-width: 768px) {
    background-color: #000;
    max-height: 100dvh;
  }
`;

export const InnerEditorContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1; /* Take up all available space */
  overflow: hidden; /* Prevent overflow issues */
`;
